import { render, staticRenderFns } from "./ContainedPageLayout.vue?vue&type=template&id=05ef1f91&scoped=true&"
import script from "./ContainedPageLayout.vue?vue&type=script&lang=js&"
export * from "./ContainedPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ContainedPageLayout.vue?vue&type=style&index=0&id=05ef1f91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ef1f91",
  null
  
)

export default component.exports